<template>
  <div class="preview">
    <PlatformPreview :platform="platform" />
  </div>
</template>

<script>
import PlatformPreview from "@/components/admin/platform/PlatformPreview.vue";
export default {
  name: "PlatformPreviewView",
  components: {
    PlatformPreview,
  },
  data() {
    return {
      platform: null,

      broadcastChannel: null,
    };
  },
  created() {
    this.broadcastChannel = new BroadcastChannel("platform-editor");
    this.broadcastChannel.onmessage = (event) => {
      this.platform = event.data;
    };
  },
  mounted() {
    this.broadcastChannel.postMessage({
      type: "getPlatform",
    });
  },
};
</script>
